import {licensingConstants} from '../../constants/index';
import jwtDecode from 'jwt-decode';

const initialState = {
  requestPending: false,
  profile: null
};

export function licensing(state = initialState, action) {
  switch (action.type) {
    case licensingConstants.VALIDATE_LICENSE_REQUEST:
      return {...state,
        requestPending: true
      };
    case licensingConstants.VALIDATE_LICENSE_SUCCESS:
      return {...state,
        license: action.licensing,
        requestPending: false
      };
    case licensingConstants.VALIDATE_LICENSE_FAILURE:
      return {...state,
        error: action.error,
        license: null,
        requestPending: false
      };
      case licensingConstants.GET_LICENSE_REQUEST:
      return {...state,
        requestPending: true
      };
    case licensingConstants.GET_LICENSE_SUCCESS:
      return {...state,
        license: action.licensing,
        requestPending: false
      };
    case licensingConstants.GET_LICENSE_FAILURE:
      return {...state,
        error: action.error,
        license: null,
        requestPending: false
      };
    case licensingConstants.UPLOAD_LICENSE_REQUEST:
      return {...state,
        requestPending: true
      };
    case licensingConstants.UPLOAD_LICENSE_SUCCESS:
      return {...state,
        license: action.licensing,
        requestPending: false
      };
    case licensingConstants.UPLOAD_LICENSE_FAILURE:
      return {...state,
        error: action.error,
        license: null,
        requestPending: false
      };
    default:
      return state
  }
}
